import { Box, Card, CardContent, Divider } from '@mui/material';
import Header from '@/component/Header';
import AddPositionForm from '@/component/stake-db/position/AddPositionForm';

export default function StakeDbAddPosition() {
  return (
    <Box
      sx={{
        display: 'flex',
        overflow: 'auto',
        flex: 1,
        flexDirection: 'column',
        gap: { xs: '16px', sm: '0px' },
      }}
    >
      <Card>
        <Header title="Stake-db 수동 스테이킹 등록" />
        <Divider />
        <CardContent
          sx={{
            maxHeight: '80vh',
            overflow: 'auto',
          }}
        >
          <AddPositionForm />
        </CardContent>
      </Card>
    </Box>
  );
}
